import GearIcon from "@redotech/redo-icons/settings-02.svg";
import { VoiceDeviceState } from "@redotech/redo-support-common/support/voice/voice-types";
import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RedoButton } from "../arbiter-components/buttons/redo-button";
import { RedoPhoneNumberInput } from "../arbiter-components/input/redo-phone-number-input";
import { Flex } from "../flex";
import { PhoneWidgetNumpad } from "./shared/phone-numpad";
import { PhoneWidgetStatus } from "./shared/phone-status";

export const PhoneIdle = memo(function NoCallBody({
  status,
  performCall,
}: {
  status: VoiceDeviceState;
  performCall: (number: string) => void;
}) {
  return (
    <>
      <PhoneWidgetSettings status={status} />
      <PhoneWidgetBody performCall={performCall} />
    </>
  );
});

const PhoneWidgetBody = memo(function PhoneWidgetBody({
  performCall,
}: {
  performCall(number: string): void;
}) {
  const [number, setNumber] = useState<string>("");

  return (
    <Flex dir="column" p="xl">
      <RedoPhoneNumberInput setValue={setNumber} value={number} />
      <PhoneWidgetNumpad
        itemPressed={(item) => setNumber((number) => number + item)}
      />
      <RedoButton
        hierarchy="primary"
        onClick={() => performCall(number)}
        text="Call"
        theme="success"
      />
    </Flex>
  );
});

/** Status is derived from the work schedule and channel picker, so it is read-only here. */
const PhoneWidgetSettings = memo(function PhoneWidgetSettings({
  status,
}: {
  status: VoiceDeviceState;
}) {
  const navigate = useNavigate();
  return (
    <Flex align="center" justify="space-between" p="xl">
      <PhoneWidgetStatus status={status} />
      <RedoButton
        aria-label="Settings"
        hierarchy="secondary"
        IconLeading={GearIcon}
        onClick={() => navigate("/settings/channels/voice-settings")}
      />
    </Flex>
  );
});
